module.exports = __webpack_public_path__ + "static/img/10.59278a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/10.png
// module id = O8bO
// module chunks = 0